/**
 * Carousel Cards Offpage - Glider.js Implementation with Fractional Slides
 */

(function () {
	'use strict';

	// Initialize carousel
	function initCarousel($block) {
		const blockElement = $block || document;
		const carousels = blockElement.querySelectorAll('.carousel-cards-offpage .glider');

		carousels.forEach(function (carousel) {
			if (carousel.classList.contains('glider-initialized')) return;

			const carouselId = carousel.id;
			const prevBtn = blockElement.querySelector('.btn-carousel-prev[data-carousel="' + carouselId + '"]');
			const nextBtn = blockElement.querySelector('.btn-carousel-next[data-carousel="' + carouselId + '"]');
			const carouselBlock = carousel.closest('.carousel-cards-offpage');
			const dotsContainer = carouselBlock ? carouselBlock.querySelector('.carousel-cards-offpage-dots') : null;

			carousel.classList.add('glider-initialized');

			const baseSlides = parseInt(carousel.getAttribute('data-slides-to-show')) || 3;
			const gliderOptions = {
				  slidesToScroll: 1,
				  slidesToShow: 5.5,
				  draggable: true,
				scrollLock: false,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: baseSlides + 0.6,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 1,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
				]
			};

			if (prevBtn && nextBtn) {
				gliderOptions.arrows = {
					prev: prevBtn,
					next: nextBtn
				};
			}

			const glider = new Glider(carousel, gliderOptions);
			carousel.gliderInstance = glider;

			const gliderContain = carousel.closest('.glider-contain');
			if (gliderContain) {
				gliderContain.classList.add('glider-loaded');
			}

			const totalSlides = glider.slides.length;
			const numDots = Math.max(1, totalSlides - baseSlides + 1);

			if (dotsContainer) {
				dotsContainer.classList.add('glider-dots');
				dotsContainer.innerHTML = '';
				for (let i = 0; i < numDots; i++) {
					const dot = document.createElement('button');
					dot.setAttribute('data-index', i);
					dot.setAttribute('aria-label', 'Card ' + (i + 1));
					dot.setAttribute('role', 'tab');
					dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
					dot.className = 'glider-dot' + (i === 0 ? ' active' : '');
					dot.addEventListener('click', function () {
						glider.scrollItem(i);
					});
					dotsContainer.appendChild(dot);
				}

				if (typeof window.r55RovingNav === 'function') {
					window.r55RovingNav(dotsContainer.querySelectorAll('.glider-dot'), {
						orientation: 'horizontal',
						onNavigate: function (el) {
							el.click();
						}
					});
				}
			}

			function updateState() {
				const currentSlide = glider.slide;

				if (dotsContainer) {
					const dots = dotsContainer.querySelectorAll('.glider-dot');
					dots.forEach(function (dot, index) {
						const isActive = index === currentSlide;
						dot.classList.toggle('active', isActive);
						dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
					});
				}

				if (prevBtn) {
					const atStart = glider.scrollLeft <= 0;
					prevBtn.toggleAttribute('disabled', atStart);
					prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
				}

				if (nextBtn) {
					nextBtn.toggleAttribute('disabled', currentSlide >= numDots - 1);
					nextBtn.setAttribute('aria-disabled', currentSlide >= numDots - 1 ? 'true' : 'false');
				}
			}

			updateState();
			carousel.addEventListener('glider-slide-visible', updateState);

			// When the cards don't fill the row, center the track instead of bunching left
			function updateCentering() {
				const fits = carousel.scrollWidth <= carousel.clientWidth + 1;
				if (carouselBlock) {
					carouselBlock.classList.toggle('cards-centered', fits);
				}
			}

			updateCentering();
			window.addEventListener('resize', updateCentering);
		});
	}

	// Initialize when DOM is ready (front-end)
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			if (typeof Glider !== 'undefined') {
				initCarousel();
			}
		});
	} else {
		if (typeof Glider !== 'undefined') {
			initCarousel();
		}
	}

	// Initialize in ACF block editor
	if (window.acf) {
		const hookNames = [
			'render_block_preview/type=carousel-cards-offpage',
			'render_block_preview/type=acf/carousel-cards-offpage',
			'render_block_preview'
		];

		hookNames.forEach(function (hookName) {
			window.acf.addAction(hookName, function ($block) {
				if ($block && $block[0] && $block[0].querySelector('.carousel-cards-offpage')) {
					setTimeout(function () {
						if (typeof Glider !== 'undefined') {
							initCarousel($block[0]);
						}
					}, 200);
				}
			});
		});

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', function () {
				if (typeof Glider !== 'undefined') {
					setTimeout(function () {
						initCarousel();
					}, 500);
				}
			});
		}
	}

})();